import { Injectable, inject } from "@angular/core";

import { AUTH_KEY } from "@app/core/auth/auth.reducer";
import { LocalStorageService } from "@app/core/local-storage/local-storage.service";
import { HttpRequest } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class AuthService {
  private localStorageService = inject(LocalStorageService);
  private httpClient = inject(HttpClient);

  isAuthenticated = false;
  cachedRequests: Array<HttpRequest<any>> = [];

  public collectFailedRequest(request): void {
    this.cachedRequests.push(request);
  }

  getToken(): string {
    return this.localStorageService.getItem(AUTH_KEY);
  }

  public retryFailedRequests(): void {
    /*TODO: this method might be called after token refresh;*/
  }
}
